<template>
	<li v-if="type=='unhead'" class="media">
		<div class="media-body">
			<h5 class="user">{{data.user}} <small class="pull-right time" v-if="this.time!='bottom'">{{data.time|goodTime}}</small> </h5>
			<slot name="body"></slot>
			{{data.content}}
			<p class="time" v-if="this.time=='bottom'">{{data.time|goodTime}}</p>
		</div>
	</li>
	<!--<li v-else-if="type=='unknow'" class="media">
	</li>
	预留一个样式-->
	<li v-else class="media">
		<div class="media-left">
			<slot name="left"></slot>
			<template v-if="!!data">
				<a href="#">
					<img class="media-object" :class="[{'img-circle':circle}]" src="../../../assets/imgs/profilepicture.jpg">
				</a>
			</template>
		</div>
		<div class="media-body" :class="{'media-middle':middle}">
			<slot name="body"></slot>
			<template v-if="!!data">
				<h5 class="media-heading">{{data.username}}</h5> {{data.content}}
				<p v-if="!hasright"><span class="pull-right time">{{data.time|goodTime}}</span></p>
			</template>
		</div>
		<div class="media-right" v-if="!!hasright">
			<slot name="right"></slot>
			<template v-if="!!data">
				<span class="time">{{data.time|goodTime}}</span>
				<br />
				<badges :max="99" :val="data.msgcount" imp></badges>
				<slot class="right"></slot>
			</template>
		</div>
	</li>
</template>
<script>
	import lib from "../../../assets/js/lib.js"
	import badges from 'components/comp/badges'
	export default {
		components: {
			lib,
			badges
		},
		props: {
			type: String,
			data: Object,
			hasright: Boolean,
			circle: Boolean,
			middle: Boolean,
			time: String
		},
		methods: {

		},
		computed: {
			mediaImg() {
				return this.circle ? "img-circle" : "";
			}
		},
		filters: {
		}
	}
</script>
<style lang="less">
	@import (reference) "../../../assets/lib/css.less";
	.media {
		&-object {
			width: 38px;
			height: 38px;
		}
		.pdt;
		.pdb;
		&-body {
			.media-heading {
				color: @cc;
			}
			h5.user {
				color: @cc;
				.mgt(0);
				small {}
			}
			.time {
				color: @cc2;
			}
			p.time {
				.mgt(@mpb/2);
			}
		}
		p {
			.mgb(0)
		}
		&-right {
			min-width: 60px;
		}
		.showinfo {
			position: fixed;
		}
	}
	
	.media+.media {
		.mgt(0);
		.bdrt;
	}
</style>


// WEBPACK FOOTER //
// media.vue?2c307c24